import { getContext, setContext } from "svelte";

const CHECKBOX_CTX = Symbol("checkbox-ctx");

let counter = 0;
export const generateCheckboxId = () => {
  const id = `sw-checkbox-${counter}`;
  counter += 1;
  return id;
};

class MultiCheckboxContext {
  #singleCheckboxStates = $state({});

  #all = $derived.by(() => {
    const values = Object.values(this.#singleCheckboxStates)
      .filter((item) => !item.disabled)
      .map((item) => item.checked);
    if (values.length === 0) {
      return "false";
    }
    if (values.every(Boolean)) {
      return "true";
    }
    if (values.every((p) => !p)) {
      return "false";
    }
    return "mixed";
  });

  get all() {
    return this.#all;
  }

  set all(value) {
    const v = !!value;
    Object.values(this.#singleCheckboxStates).forEach((item) => {
      if (item.disabled) {
        return;
      }
      item.checked = v;
    });
  }

  add(id, states) {
    this.#singleCheckboxStates[id] = states;
  }

  delete(id) {
    delete this.#singleCheckboxStates[id];
    this.#singleCheckboxStates = { ...this.#singleCheckboxStates };
  }
}

export const createMultiCheckboxContext = () => {
  const context = new MultiCheckboxContext();
  setContext(CHECKBOX_CTX, context);
  return context;
};

// Allow checkboxes with no multi-checkbox context.
export const getMultiCheckboxContext = () => getContext(CHECKBOX_CTX);
